import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";

import App from "./app.tsx";

document.title = "Lager";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
